import {ActionMenu, ThemeProvider} from '@primer/react-brand'
import editors from '@github-ui/global-copilot-menu/editors'
import {recordMenuClick} from '@github-ui/global-copilot-menu/EditorMenuItems'

import {AzureDataStudioLogo} from './icons/AzureDataStudioLogo'
import {JetBrainsLogo} from './icons/JetBrainsLogo'
import {NeoVimLogo} from './icons/NeoVimLogo'
import {VisualStudioLogo} from './icons/VisualStudioLogo'
import {VisualStudioCodeLogo} from './icons/VisualStudioCodeLogo'
import {XcodeLogo} from './icons/XcodeLogo'

const editorIcons: Record<keyof typeof editors, JSX.Element> = {
  vscode: <VisualStudioCodeLogo />,
  visualstudio: <VisualStudioLogo />,
  xcode: <XcodeLogo />,
  jetbrains: <JetBrainsLogo />,
  neovim: <NeoVimLogo />,
}

const allEditors = {
  ...Object.fromEntries(
    Object.entries(editors).map(([key, value]) => [
      key,
      {
        name: value.name,
        url: value.url,
        icon: editorIcons[key as keyof typeof editorIcons],
      },
    ]),
  ),
  azure_data_studio: {
    name: 'Azure Data Studio',
    url: 'https://learn.microsoft.com/en-us/azure-data-studio/extensions/github-copilot-extension-overview',
    icon: <AzureDataStudioLogo />,
  },
} as Record<keyof typeof editors | 'azure_data_studio', {name: string; url: string; icon: JSX.Element}>

export type IdeLinks = typeof allEditors

type Props = {
  deepLinks?: IdeLinks
}

export default function IdeCta({deepLinks}: Props) {
  return (
    <ThemeProvider colorMode="light" style={{background: 'transparent'}}>
      <ActionMenu mode="split-button">
        <ActionMenu.Button
          variant="subtle"
          as="a"
          href={deepLinks?.vscode?.url || allEditors.vscode.url}
          leadingVisual={allEditors.vscode.icon}
        >
          Install Copilot in Visual Studio Code
        </ActionMenu.Button>

        <ActionMenu.Overlay aria-label="Alternative actions">
          {Object.entries(allEditors).map(([editor, {name, url, icon}]) => {
            return (
              <ActionMenu.Item
                key={editor}
                as="a"
                href={deepLinks?.[editor as keyof IdeLinks]?.url || url}
                leadingVisual={icon}
                onClick={() => {
                  recordMenuClick(editor, 'marketing_ide_cta')
                }}
              >
                <span style={{whiteSpace: 'nowrap'}}>{name}</span>
              </ActionMenu.Item>
            )
          })}
        </ActionMenu.Overlay>
      </ActionMenu>
    </ThemeProvider>
  )
}

try{ IdeCta.displayName ||= 'IdeCta' } catch {}